import { useBetSliderStore } from '@stores/betSliderStore'
import { useBuyBonusStore } from '@stores/buyBonusStore'
import { useConfigurationStore } from '@stores/configurationStore'
import { isBetOptionItem } from '@utils/betOption'

const useGetBetAmount = () => {
    const betOptions = useConfigurationStore((state) => state.betOptions)
    const activeIndex = useBetSliderStore((state) => state.activeIndex)
    const currentFeatureMultiplier = useBuyBonusStore((s) => s.currentFeatureMultiplier)
    const getActiveBetOption = useBetSliderStore((state) => state.getActiveBetOption)

    return (
        (isBetOptionItem(betOptions[activeIndex]) ? (getActiveBetOption()?.betAmount ?? 0) : +betOptions[activeIndex]) *
        currentFeatureMultiplier
    )
}

export default useGetBetAmount
